export const FIRST_AD_PROMPT='Make 5 ads for Black Friday 50% Off';
